import Vue from 'vue';
import axios from '@/api/axios-auth';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import filters from '@/filters';
import BootstrapVue from 'bootstrap-vue';
import ProductZoomer from 'vue-product-zoomer';
import VueTreeNavigation from 'vue-tree-navigation';
import 'jquery/src/jquery.js';
import 'popper.js/dist/popper.min.js';
import 'bootstrap/dist/js/bootstrap.min.js';
import { library } from '@fortawesome/fontawesome-svg-core';
import * as iconsModule from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome';
import VueGtag from 'vue-gtag';
import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import moment from 'moment';
import JsonCSV from 'vue-json-csv'
import { StripePlugin } from '@vue-stripe/vue-stripe';
const { fas, prefix, ...icons } = iconsModule;


const options = {
  pk: process.env.STRIPE_KEY,
  testMode: process.env.TEST_MODE, // Boolean. To override the insecure host warning
};

Vue.use(StripePlugin, options)

library.add(...Object.values(icons));
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('font-awesome-layers', FontAwesomeLayers);
Vue.component('font-awesome-layers-text', FontAwesomeLayersText);
Vue.component('downloadCsv', JsonCSV)
Vue.use(BootstrapVue);
Vue.use(ProductZoomer);
Vue.use(VueTreeNavigation);
Vue.use(filters);
Vue.use(
  VueGtag,
  {
    config: { id: process.env.VUE_APP_GTAG },
  },
  router
);
/*Sentry.init({
  Vue,
  environment: 'production',
  dsn: 'https://0b1df04f5182425fa281389c10e00ab2@o1057314.ingest.sentry.io/6044024',
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: [process.env.VUE_SENTRY_ORIGINS],
      logErrors: true,
    }),
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});*/
Vue.use(Antd);

Vue.config.productionTip = false;
Vue.component('datetime', VueCtkDateTimePicker);
Vue.prototype.moment = moment;

const token = localStorage.getItem('jwtToken');
if (token) {
  axios.defaults.headers.common.Authorization = 'Bearer ' + token;
}

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
